import { sumBy } from 'lodash-es';

import { useGetVisibleXDataGridProColumns } from '@/hooks';
import { roundNDecimal } from '@/utils';

import { Stack, Typography } from '@mui/joy';
import { TypographyProps } from '@mui/joy';
import { GridFooterContainer, useGridApiContext } from '@mui/x-data-grid-pro';

const FooterText = ({ children, sx }: TypographyProps) => {
  return (
    <Typography
      level='body-xs'
      textColor='neutral.700'
      sx={{
        b: {
          fontSize: '0.875rem',
        },
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
};

export const CustomFooter = ({
  rows,
  columnsToSum,
  hasAction,
  countedTotal = false,
}: {
  rows?: any[];
  columnsToSum?: [string, string, (string | number)?][];
  hasAction?: boolean;
  countedTotal?: boolean;
}) => {
  const apiRef = useGridApiContext();
  const { gridTemplateColumns } = useGetVisibleXDataGridProColumns(
    apiRef.current,
  );

  const totals =
    !countedTotal &&
    columnsToSum.reduce(
      (acc, [column]) => {
        acc[column] = sumBy(rows, row => row[column] || 0);
        return acc;
      },
      {} as Record<string, number>,
    );

  return (
    <GridFooterContainer
      sx={{
        display: 'grid',
        gridTemplateColumns: gridTemplateColumns
          .map(col => `${col.computedWidth}px`)
          .join(' '),
        p: 0,
        '& > *': { p: '8px 10px' },
      }}
    >
      <Stack
        sx={{
          flex: 1,
        }}
      >
        Всього{' '}
      </Stack>
      {columnsToSum.map(([column, unit, total], index) => (
        <Stack
          key={index}
          sx={{
            flex: 1,
            flexDirection: 'row',
          }}
        >
          {countedTotal ? (
            <FooterText>
              <b>{roundNDecimal(total)}</b> {unit}
            </FooterText>
          ) : (
            totals[column] !== 0 && (
              <FooterText>
                <b>{roundNDecimal(totals[column])}</b> ({unit})
              </FooterText>
            )
          )}
        </Stack>
      ))}
      {hasAction && (
        <Stack sx={{ width: '90px', paddingRight: '10px' }}></Stack>
      )}
    </GridFooterContainer>
  );
};

export default CustomFooter;
